// Ported verbatim from WOOF1_eCRF_v7.html (source line 1652, const ROLES).
// This is fixed application logic, not tenant-editable data - keep it a
// shared constant so every service agrees on what "all"|"site"|"none" means.
export type PermLevel = "all" | "site" | "none";

export interface RoleDef {
  code: string;
  label: string;
  perms: {
    read: PermLevel;
    write: PermLevel;
    modify: PermLevel;
    admin: boolean;
    audit: boolean;
  };
}

export const ROLES: Record<string, RoleDef> = {
  ADMIN: {
    code: "ADMIN",
    label: "Administrateur",
    perms: { read: "all", write: "all", modify: "all", admin: true, audit: true },
  },
  DM_SPONSOR: {
    code: "DM_SPONSOR",
    label: "Data Manager Sponsor",
    perms: { read: "all", write: "all", modify: "all", admin: false, audit: true },
  },
  INVESTIGATOR: {
    code: "INVESTIGATOR",
    label: "Investigateur",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  CRA_LOCAL: {
    code: "CRA_LOCAL",
    label: "ARC local",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  MONITOR_LOCAL: {
    code: "MONITOR_LOCAL",
    label: "Moniteur local",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  PROJECT_MANAGER: {
    code: "PROJECT_MANAGER",
    label: "Chef de projet Findimmune",
    perms: { read: "all", write: "none", modify: "none", admin: false, audit: true },
  },
  CRA_CRO: {
    code: "CRA_CRO",
    label: "ARC/Moniteur CRO",
    perms: { read: "all", write: "none", modify: "none", admin: false, audit: true },
  },
  // Short aliases (v7), used by seeded users
  INV: {
    code: "INV",
    label: "Investigateur",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  ARC: {
    code: "ARC",
    label: "ARC (Attaché Recherche Clinique)",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  MON: {
    code: "MON",
    label: "Moniteur",
    perms: { read: "site", write: "site", modify: "site", admin: false, audit: true },
  },
  SPONSOR: {
    code: "SPONSOR",
    label: "Findimmune (sponsor)",
    perms: { read: "all", write: "none", modify: "none", admin: false, audit: true },
  },
  SATT: {
    code: "SATT",
    label: "SATT",
    perms: { read: "all", write: "none", modify: "none", admin: false, audit: true },
  },
};

// Roles allowed to trigger the bulk "export all patients" CSV (source: exportAllPatientsCSV).
export const BULK_EXPORT_ROLES = ["ADMIN", "DM_SPONSOR", "PROJECT_MANAGER", "CRA_CRO"];

// Roles allowed to set/change AE.preferred_term (MedDRA code) - UI-locked in source,
// now server-enforced per the rebuild's deliberate tightening.
export const PREFERRED_TERM_WRITE_ROLES = ["ADMIN", "DM_SPONSOR", "SPONSOR"];

// Queries workflow separation of duties (see services/queries): raising,
// closing, reopening, and reassigning a query is a monitoring/data-management
// action, while answering one is a site-staff action. ADMIN can do both.
export const QUERY_MANAGE_ROLES = ["ADMIN", "DM_SPONSOR", "CRA_LOCAL", "ARC", "MONITOR_LOCAL", "MON"];
export const QUERY_ANSWER_ROLES = ["ADMIN", "INVESTIGATOR", "INV"];
